import React from 'react';
import HistoryDate from './HistoryDate';
import withReactContent from 'sweetalert2-react-content';
import { FileText, Trash } from 'react-feather';
import Swal from 'sweetalert2';
import { getHistory } from '../../../redux/history/slices';
import Player from './Player';
import Download from './Download';
import { dispatch } from '../../../redux';
import axios from 'axios';
import store from '../../../redux';

const ReactSwal = withReactContent(Swal);

const handleRead = (text) => {
    ReactSwal.fire({
        text: text,
        confirmButtonText: 'Close',
        customClass: {
            confirmButton: 'btn btn-primary btn-sm btn-block',
            text: 'text-center text-wrap text-break text-body text-sm text-start text-md text-lg text-xl'
        },
        buttonsStyling: false
    })
};

const userToken = store.getState().auth.login.data.access_token
const token = `Bearer ${userToken}`
const handleDelete = (id) => {
    ReactSwal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this file!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ms-1'
        },
        buttonsStyling: false,

        preConfirm() {
            return axios.post(`${process.env.REACT_APP_API_BASE_URL}/wave/delete`, {
                "wav_name": id.wav_name
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            })
                .catch((error) => {
                    ReactSwal.showValidationMessage(`Request failed:  ${error.response.data}`);
                });
        }
    }).then((result) => {
        if (result.isConfirmed) {
            // get history after delete and rerender the table
            dispatch(getHistory());
            ReactSwal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: {
                    confirmButton: 'btn btn-success'
                }
            });
        }
    })
};

const columns = [
    {
        name: 'file name',
        selector: 'wav_name',
        minWidth: '130px',
        selector: (row) => row.Wav_name,
        cell: (row) => {
            return (

                <h6 className="row d-flex align-items-center">
                    {row.wav_name}
                </h6>

            );
        }
    },
    {
        name: 'generation time',
        selector: 'speaker',
        minWidth: '200px',
        selector: (row) => row.wav_name,
        cell: (row) => {
            return (
                <div className="row">
                    <HistoryDate name={row.wav_name} />
                </div>

            );
        }
    },
    {
        name: 'language',
        selector: 'language',
        minWidth: '120px',
        selector: (row) => row.speaker.language,
        cell: (row) => {
            return (
                <div className="row">
                    {row.speaker?.language}
                </div>
            );
        }
    },
    {
        name: 'voice name',
        selector: 'name',
        minWidth: '120px',
        selector: (row) => row.speaker.name,
        cell: (row) => {
            return (
                <div className="row">
                    {row['speaker']?.name}
                </div>
            )
        }
    },
    {
        name: 'gender',
        selector: 'gender',
        minWidth: '10px',
        selector: (row) => row.gender,
        cell: (row) => {
            const gender = row.speaker?.gender?.toLowerCase();
            return (
                <div className="row">
                    {gender.charAt(0).toUpperCase() + gender.slice(1)}
                </div>
            )
        }
    },
    {
        name: 'word-count',
        selector: 'word_count',
        minWidth: '20px',
        sortField: 'word_count',
        selector: (row) => row.text?.trim().split(' ').length,
        style: {
            textAlign: 'center'

        },
        cell: (row) => {
            return (
                <div className="row d-flex align-items-center">
                    {row.text?.trim().split(' ').length}
                </div>
            )
        }
    },
    {
        name: 'text',
        selector: 'text',
        minWidth: '10px',
        selector: (row) => row.text,
        cell: (row) => {
            return (
                <div className="cursor-pointer">
                    <FileText onClick={() => handleRead(row.text)} size={20} />
                </div>
            )
        }
    },
    {
        name: 'play',
        selector: 'play',
        minWidth: '10px',
        selector: (row) => row.play,
        cell: (row) => {
            const stopAllAudio = () => {
                const audios = document.getElementsByTagName('audio');
                for (let i = 0, len = audios.length; i < len; i++) {
                    audios[i].pause();
                }
            };
            return (
                <div className="row">
                    <Player audioName={row.wav_name} stopAllAudio={stopAllAudio} />
                </div>
            )
        }
    },
    {
        name: 'download',
        selector: 'download',
        minWidth: '10px',
        selector: (row) => row.download,
        cell: (row) => {
            return (
                <div className="row cursor-pointer align-items-center">
                    <Download audioName={row.wav_name} />
                </div>
            )
        }
    },
    {
        name: 'delete',
        selector: 'delete',
        minWidth: '10px',
        selector: (row) => row.delete,
        cell: (row) => {
            return (
                <div className="row">
                    <Trash onClick={() => handleDelete({
                        wav_name: row.wav_name,
                    })}
                        className="text-danger cursor-pointer"
                        size={20}
                    />
                </div>
            )
        }

    }

];



export default columns;